export class ResumeCreateRequest {
    candidateId:number
    name:string
    file:File|null
    constructor() {
        this.candidateId = 0
        this.name = ''
        this.file = null
    }
}